import { jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { useDateSegment } from "@react-aria/datepicker";
import { Box } from "../Box/Box.mjs";
import { dateSegment } from "./DateSegment.css.mjs";
function DateSegment({ segment, state, isReadonly }) {
  const ref = useRef(null);
  const { segmentProps } = useDateSegment(segment, state, ref);
  return /* @__PURE__ */ jsx(Box, { ...segmentProps, readOnly: isReadonly, className: dateSegment, ref, children: segment.text });
}
export {
  DateSegment
};
